import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';

/**
 * High Temp merchandisers list (PD-13938) — units whose sensor-reported
 * temperature (bubbled up from the attached sensor device at ingestion) is
 * at/above MERCHANDISER_HIGH_TEMP_THRESHOLD — an ice unit warming above its
 * safe range. Filters on the derived `merchandiserHighTemp` quick-filter.
 */
export const highTempMerchandisersList: ListBuilderList = {
	id: 'default-merchandisers-high-temp',
	name: 'High Temp',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		merchandiserHighTemp: {
			defaultValue: [{ id: 'high', label: 'High Temp' }],
		},
	},
	columns: createMerchandiserColumns(),
	defaultSortId: 'merchandiser-name',
	sortOrder: 4,
};
